import secondaryButtonRule from '../../secondary-button/branded-solid/background/default';

const primary = (params) => secondaryButtonRule.primary(params);

export default primary;
